var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"active",attrs:{"id":"spinner"}},[_c('span',{staticClass:"ball -yellow",attrs:{"id":"first"}}),_vm._v(" "),_c('span',{staticClass:"ball",attrs:{"id":"second"}}),_vm._v(" "),_c('span',{staticClass:"ball",attrs:{"id":"third"}}),_vm._v(" "),_c('span',{staticClass:"ball",attrs:{"id":"fourth"}})])])
}]

export { render, staticRenderFns }